import './TheBizInfo.css'; // Import the CSS
import htmlContent from './TheBizInfo.html?raw'; // Import HTML as a raw string

class TheBizInfo {
  constructor(container) {
    this.container = container;
    this.typewriterData = {
      'type-b': ['Creators', 'Businesses', 'Everyday people', 'Influencers', 'Artists', 'Developers', 'Designers'],
    };
  }

  async render() {
    try {
      // const response = await fetch('./src/components/Content/TheBizInfo.html');
      // const htmlContent = await response.text();
      this.container.innerHTML = htmlContent; // Use the imported string directly
      this.setupEventListeners();
      this.initTypewriters();
      
      // Add a subtle load animation
      this.container.style.opacity = '0';
      this.container.style.transform = 'translateY(10px)';
      this.container.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
      
      setTimeout(() => {
        this.container.style.opacity = '1';
        this.container.style.transform = 'translateY(0)';
      }, 50);
      
    } catch (error) {
      console.error('Error rendering TheBizInfo component:', error);
      this.container.innerHTML = '<p>Error loading content. Please refresh the page.</p>';
    }
  }

  setupEventListeners() {
    const expandableTrigger = this.container.querySelector('.the-biz-expandable-trigger');
    const expandableContent = this.container.querySelector('.the-biz-expandable-content');
    const expandableTextSpan = this.container.querySelector('.the-biz-expandable-text');

    if (expandableTrigger && expandableContent && expandableTextSpan) {
      expandableTrigger.addEventListener('click', () => {
        const isOpen = expandableTrigger.classList.toggle('open');
        expandableContent.classList.toggle('open');
        expandableTextSpan.textContent = isOpen ? 'Say Less' : 'Say More';
        
        // Enhance accessibility
        expandableTrigger.setAttribute('aria-expanded', isOpen);
        expandableContent.setAttribute('aria-hidden', !isOpen);
        
        // Remove focus after interaction to prevent persistent outline
        expandableTrigger.blur();
      });

      // Add keyboard accessibility
      expandableTrigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          expandableTrigger.click();
        }
      });

      // Make expandable trigger focusable
      expandableTrigger.setAttribute('tabindex', '0');
      expandableTrigger.setAttribute('role', 'button');
      expandableTrigger.setAttribute('aria-expanded', 'false');
      expandableContent.setAttribute('aria-hidden', 'true');
    }
  }
  
  initTypewriters() {
    this.container.querySelectorAll('.the-biz-typewriter').forEach(el => {
      const options = this.typewriterData[el.dataset.typewriterFor];
      if (options && options.length) this.runTypewriter(el, options);
    });
  }

  runTypewriter(el, options) {
    const TYPE_MS = 80;
    const DELETE_MS = 40;
    const HOLD_MS = 1600;
    const PAUSE_MS = 400;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let optionIndex = 0;
    let charIndex = 0;
    let deleting = false;

    const tick = () => {
      // Stop once the page has been re-rendered or closed
      if (!el.isConnected) return;

      if (reduceMotion) {
        el.textContent = options[optionIndex];
        optionIndex = (optionIndex + 1) % options.length;
        setTimeout(tick, HOLD_MS * 1.5);
        return;
      }

      const word = options[optionIndex];
      if (!deleting) {
        charIndex++;
        el.textContent = word.slice(0, charIndex);
        if (charIndex === word.length) {
          deleting = true;
          setTimeout(tick, HOLD_MS);
        } else {
          setTimeout(tick, TYPE_MS);
        }
      } else {
        charIndex--;
        el.textContent = word.slice(0, charIndex);
        if (charIndex === 0) {
          deleting = false;
          optionIndex = (optionIndex + 1) % options.length;
          setTimeout(tick, PAUSE_MS);
        } else {
          setTimeout(tick, DELETE_MS);
        }
      }
    };

    // Defer so the tab has been attached to the page before the first tick
    setTimeout(tick, 0);
  }
}

export default TheBizInfo; 